module.exports = __webpack_public_path__ + "static/media/189-austria.de09d6cd.svg";